// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tnLz","input":"styles_input__15ulJ"};